import React, { memo, useMemo } from 'react';
import { IconButton, Typography, Stack, Box } from '@mui/material';
import { PlayArrow, Pause } from '@mui/icons-material';
import { formatTime } from './audioUtils';

const PlaybackControls = memo(({ 
    isPlaying, 
    isLoading, 
    currentTime, 
    duration, 
    onPlayPause, 
    colors 
}) => {
    const formattedCurrentTime = useMemo(() => formatTime(currentTime), [currentTime]);
    const formattedDuration = useMemo(() => formatTime(duration), [duration]);

    return (
        <Stack direction="row" spacing={1} alignItems="center">
            <IconButton 
                onClick={onPlayPause} 
                disabled={isLoading}
                sx={{
                    bgcolor: colors.buttonBg,
                    color: '#ffffff',
                    '&:hover': {
                        bgcolor: colors.buttonHover,
                    },
                    '&:disabled': {
                        bgcolor: colors.buttonDisabled,
                    },
                    width: 48,
                    height: 48
                }}
            >
                {isPlaying ? <Pause /> : <PlayArrow />}
            </IconButton>
            
            <Box>
                <Typography 
                    variant="body2" 
                    sx={{ 
                        fontWeight: 600,
                        color: colors.textPrimary,
                        fontFamily: 'monospace'
                    }}
                >
                    {formattedCurrentTime}
                </Typography>
                <Typography 
                    variant="caption" 
                    sx={{ 
                        color: colors.textSecondary,
                        fontFamily: 'monospace'
                    }}
                >
                    / {formattedDuration}
                </Typography>
            </Box>
        </Stack>
    );
});

PlaybackControls.displayName = 'PlaybackControls';

export default PlaybackControls;

